import React, { FC, useMemo } from 'react';
import styles from './index.module.scss';
import { hexToRgb } from 'src/helpers/styles';
import { HighlightColor } from '@tendium/prom-types';
import { HighlightColorDict } from 'src/models/matchingProfiles/types';

interface IPreferencesKeywordsItemProps {
  keyword: string;
  color: HighlightColor;
}

export const TooltipKeywordsItem: FC<IPreferencesKeywordsItemProps> = props => {
  const { keyword, color } = props;

  const colorStyle = useMemo(() => color && { background: hexToRgb(HighlightColorDict[color]) }, [color]);

  return (
    <li className={styles.keywordsItem}>
      <span className={styles.keywordsItemInner} style={colorStyle}>
        <span className={styles.keywordsItemTitle}>{keyword}</span>
      </span>
    </li>
  );
};

export default TooltipKeywordsItem;
